
<workflow-no-access [workflowTargetInfo]="workflowTargetInfo"></workflow-no-access>
<div class="container" [hidden]="!workflowTargetInfo.correctRole">
  <div class="row mb-2" *ngIf="alertMessage">
    <div class="col-12 alert-danger rounded pt-2 pb-2"><span>{{alertMessage}}</span>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col table-card">
      <div class="m-2">
        <div class="row">
          <div class="col-12">
            <h4>Customer Detail</h4>
          </div>
        </div>
        <div class="row" *ngIf="project.customerBpId">
          <div class="col-12">
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Customer Name</div>
                <div class="border-bottom text-secondary">{{project.customerName}}&nbsp;</div>
              </div>
              <div class="form-group col-lg-6">
                <div>Customer BP ID</div>
                <div class="border-bottom text-secondary">{{project.customerBpId}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="project.resellerBpId">
          <div class="col-12">
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Reseller Name</div>
                <div class="border-bottom text-secondary">{{project.resellerName}}</div>
              </div>
              <div class="form-group col-lg-6">
                <div>Reseller BP ID</div>
                <div class="border-bottom text-secondary">{{project.resellerBpId}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="row">
              <div class="form-group col-lg-6">
                <div>Unique ID</div>
                <div class="border-bottom text-secondary">{{project.uniqueId}}</div>
              </div>
              <div class="form-group col-lg-6">
                <div>Opportunity ID</div>
                <div class="border-bottom text-secondary">{{project.opportunityId}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col table-card">
      <div class="m-2">
        <div class="row mb-3">
          <div class="col-12">
            <h4 class="float-left">Customer Fleet Sites</h4>
            <div class="float-right pb-2">
              <div class="btn-group mt-2">
                <button class="btn btn-outline-primary border-white" (click)="rejectCustomerFleet()">Reject Customer</button>
              </div>
              <div class="btn-group mt-2">
                <button class="btn btn-outline-primary" (click)="createCustomerFleet()">Create Customer</button>
              </div>
            </div>
          </div>
        </div>
        <h6>To complete this step select an existing customer fleet or create a new one</h6>
        <list-controls [search]="searchText" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"></list-controls>
        <table class="table table-responsive customer-table">
          <thead>
            <tr class="table-header-with-controls">
              <th class="actions">Fleet Selection</th>
              <th>Customer Name</th>
              <th>Contract Number</th>
              <th class="actions">Show Details</th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let customer of customers; let idx = index;">
              <ng-container *ngIf="!(project.customerFleet === customer.id &amp;&amp; idx !== 0)">
                <tr>
                  <td class="text-center form-radio">
                    <div class="tmc-radio" *ngIf="project.customerFleet === customer.id">
                      <input type="radio" checked="checked">
                      <label class="radio-label"></label>
                    </div>
                    <div class="tmc-radio" *ngIf="project.customerFleet !== customer.id">
                      <input type="radio">
                      <label class="radio-label" (click)="setCustomerFleet(customer)" title="Select customer fleet"></label>
                    </div>
                  </td>
                  <td>{{customer.name}}</td>
                  <td>{{customer.contractNumber}}</td>
                  <td class="text-center"><a class="nav-link" href="javascript:void(0);" aria-haspopup="true" aria-expanded="false" title="Show customer fleet details" (click)="toggleExpand(customer.id)"><span class="icon oi oi-chevron-bottom" *ngIf="expandId !== customer.id"></span><span class="icon oi oi-chevron-top" *ngIf="expandId === customer.id"></span></a></td>
                </tr>
                <tr *ngIf="expandId === customer.id">
                  <td class="border-top-0"></td>
                  <td class="border-top-0">
                    <div class="form-group">
                      <div>Pricing Model</div>
                      <div class="border-bottom text-secondary">{{customer.pricingModel}}&nbsp;</div>
                    </div>
                    <div class="form-group">
                      <div>Custom Header 1</div>
                      <div class="border-bottom text-secondary">{{customer.customHeading1}}&nbsp;</div>
                    </div>
                    <div class="form-group" *ngIf="editId === customer.id">
                      <label for="customHeading3">Custom Header 3</label>
                      <input class="form-control" id="customHeading3" type="text" name="customHeading3" [(ngModel)]="customer.customHeading3">
                    </div>
                    <div class="form-group" *ngIf="editId !== customer.id">
                      <div>Custom Header 3</div>
                      <div class="border-bottom text-secondary">{{customer.customHeading3}}&nbsp;</div>
                    </div>
                    <div class="form-group" *ngIf="editId === customer.id">
                      <label for="customHeading5">Custom Header 5</label>
                      <input class="form-control" id="customHeading5" type="text" name="customHeading5" [(ngModel)]="customer.customHeading5">
                    </div>
                    <div class="form-group" *ngIf="editId !== customer.id">
                      <div>Custom Header 5</div>
                      <div class="border-bottom text-secondary">{{customer.customHeading5}}&nbsp;</div>
                    </div>
                  </td>
                  <td class="border-top-0">
                    <div class="form-group">
                      <div>Billing Destination</div>
                      <div class="border-bottom text-secondary">{{customer.billDestination}}&nbsp;</div>
                    </div>
                    <div class="form-group">
                      <div>Custom Header 2</div>
                      <div class="border-bottom text-secondary">{{customer.customHeading2}}&nbsp;</div>
                    </div>
                    <div class="form-group" *ngIf="editId === customer.id">
                      <label for="customHeading4">Custom Header 4</label>
                      <input class="form-control" id="customHeading4" type="text" name="customHeading4" [(ngModel)]="customer.customHeading4">
                    </div>
                    <div class="form-group" *ngIf="editId !== customer.id">
                      <div>Custom Header 4</div>
                      <div class="border-bottom text-secondary">{{customer.customHeading4}}&nbsp;</div>
                    </div>
                    <div class="form-group">
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="billingActive" [(ngModel)]="customer.billingActive" [disabled]="editId !== customer.id">
                        <label class="form-check-label">Active Billing</label>
                      </div>
                      <div class="form-check">
                        <input class="form-check-input" type="checkbox" name="custAllSapServer" [(ngModel)]="customer.custAllSapServer" [disabled]="editId !== customer.id">
                        <label class="form-check-label">Cust All SAP Server</label>
                      </div>
                    </div>
                  </td>
                  <td class="border-top-0"></td>
                </tr>
                <tr *ngIf="expandId === customer.id">
                  <td class="border-top-0" colspan="4">
                    <div class="mr-4 mt-0 mb-5 pr-2"><a class="float-right nav-link" href="javascript:void(0)" title="Edit customer fleet" (click)="editId = customer.id" *ngIf="editId !== customer.id"><span class="oi oi-pencil">Edit</span></a><a class="float-right nav-link" href="javascript:void(0)" title="Save changes" (click)="saveCustomerFleet(customer)" *ngIf="editId === customer.id">Save Edit</a><a class="float-right nav-link text-secondary" href="javascript:void(0)" title="Cancel edit" (click)="editId = ''" *ngIf="editId === customer.id">Cancel</a></div>
                  </td>
                </tr>
              </ng-container>
            </ng-container>
            <tr *ngIf="customers.length === 0">
              <td colspan="4">
                <p class="text-center empty-table-message">There are no customers to display.</p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>